var _path, _rect, _rect2, _circle, _circle2, _circle3;
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgNotification(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, ["title", "titleId"]);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "\\u56FE\\u5C42_1",
    "data-name": "\\u56FE\\u5C42 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 64 64",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "04_\u540E\u53F0\u6D88\u606F\u7BA1\u7406") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M56,48,31,47.94a2,2,0,1,1,0-4h0L55.89,44a.15.15,0,0,0,0-.08V12a.12.12,0,0,0,0-.07h-48a.56.56,0,0,0,0,.07V43.92s0,.06,0,.08H18.71a2,2,0,1,1,0,4H7.84a4,4,0,0,1-3.93-4.08V12A4,4,0,0,1,7.84,8H56A4,4,0,0,1,59.91,12V43.92A4,4,0,0,1,56,48Z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 16.72,
    y: 44.01,
    width: 4,
    height: 11.99,
    rx: 2
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 22.8,
    y: 40.84,
    width: 4,
    height: 18.45,
    rx: 1.98,
    transform: "translate(-3.31 98.35) rotate(-123.45)"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 19.7,
    cy: 27.98,
    r: 4
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 32,
    cy: 27.98,
    r: 4
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 44.1,
    cy: 27.98,
    r: 4
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotification);
export default __webpack_public_path__ + "static/media/notification.5bbcea78.svg";
export { ForwardRef as ReactComponent };